(function () {
  var CART_ENDPOINT = '/apps/wantlist/cart';
  var CART_TO_WANTLIST_ENDPOINT = '/apps/wantlist/cart/save-to-wantlist';
  var disabled = false;
  var syncTimer = null;
  var syncRetryTimer = null;
  var lastSyncedSignature = '';
  var lastKnownRevision = null;
  var SYNC_RETRY_DELAYS = [1500, 5000, 15000];

  function fetchJson(url, options) {
    return fetch(url, Object.assign({
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    }, options || {})).then(function (response) {
      if (response.status === 401) {
        disabled = true;
      }
      return response.json().catch(function () {
        return {};
      }).then(function (body) {
        if (!response.ok) {
          var error = new Error(body.error || 'Request failed.');
          error.status = response.status;
          throw error;
        }
        return body;
      });
    });
  }

  function cartJson() {
    return fetchJson((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js');
  }

  function gidNumber(value) {
    var text = (value || '').toString();
    var match = text.match(/(\d+)$/);
    return match ? match[1] : '';
  }

  function normalizeCartItems(cart) {
    return (cart && Array.isArray(cart.items) ? cart.items : []).map(function (item) {
      return {
        variant_id: item.id || item.variant_id,
        product_id: item.product_id,
        sku: item.sku || '',
        quantity: item.quantity || 1,
        title: item.title || '',
        product_title: item.product_title || '',
        variant_title: item.variant_title || '',
        url: item.url || '',
        image_url: item.image || '',
        price: item.final_line_price || item.final_price || item.price || '',
      };
    }).filter(function (item) {
      return item.variant_id && item.quantity > 0;
    });
  }

  function signatureForItems(items) {
    return items.map(function (item) {
      return [item.variant_id, item.quantity].join(':');
    }).sort().join('|');
  }

  function savedLinesSignature(lines) {
    return (Array.isArray(lines) ? lines : []).map(function (line) {
      return [gidNumber(line.variant_gid), line.quantity || 1].join(':');
    }).sort().join('|');
  }

  function normalizeRevision(value) {
    var revision = Number(value);
    return Number.isFinite(revision) && revision >= 0 ? revision : 0;
  }

  function rememberSavedCart(saved) {
    if (!saved) return;
    lastKnownRevision = normalizeRevision(saved.revision);
    lastSyncedSignature = savedLinesSignature(saved.lines || []);
  }

  function ensureSavedCartRevision() {
    if (lastKnownRevision !== null) return Promise.resolve(lastKnownRevision);
    return fetchJson(CART_ENDPOINT).then(function (saved) {
      rememberSavedCart(saved);
      return lastKnownRevision;
    });
  }

  function scheduleSyncRetry(items, signature, attempt) {
    if (attempt >= SYNC_RETRY_DELAYS.length) return;
    window.clearTimeout(syncRetryTimer);
    syncRetryTimer = window.setTimeout(function () {
      if (signature === lastSyncedSignature || disabled) return;
      syncItems(items, attempt + 1, true);
    }, SYNC_RETRY_DELAYS[attempt]);
  }

  function syncItems(items, attempt, force) {
    if (disabled) return Promise.resolve(null);
    var signature = signatureForItems(items);
    if (!force && signature === lastSyncedSignature) return Promise.resolve(null);
    return ensureSavedCartRevision().then(function (revision) {
      return fetchJson(CART_ENDPOINT, {
        method: 'PUT',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items: items, revision: revision }),
      });
    }).then(function (saved) {
      window.clearTimeout(syncRetryTimer);
      rememberSavedCart(saved);
      lastSyncedSignature = signature;
      return saved;
    }).catch(function (error) {
      if (error.status === 401) return null;
      if (error.status === 409) {
        lastKnownRevision = null;
        console.warn('[further-saved-cart] Saved cart changed elsewhere; sync skipped until refresh.');
        return null;
      }
      if (!error.status || error.status >= 500) {
        scheduleSyncRetry(items, signature, attempt || 0);
      }
      if (error.status !== 401) {
        console.warn('[further-saved-cart] Cart sync failed:', error);
      }
      return null;
    });
  }

  function syncCurrentCart() {
    if (disabled) return;
    cartJson().then(function (cart) {
      return syncItems(normalizeCartItems(cart));
    }).catch(function (error) {
      console.warn('[further-saved-cart] Could not read cart:', error);
    });
  }

  function scheduleSync() {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(syncCurrentCart, 450);
  }

  function createButton(label, modifier) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'button' + (modifier ? ' ' + modifier : '');
    button.textContent = label;
    return button;
  }

  function renderCartPanel(container, saved, cart) {
    var currentItems = normalizeCartItems(cart);
    var currentSignature = signatureForItems(currentItems);
    var savedSignature = savedLinesSignature(saved.lines);
    var hasSaved = (saved.lines || []).length > 0;
    var hasCurrent = currentItems.length > 0;

    if (!hasSaved && !hasCurrent) {
      container.hidden = true;
      return;
    }

    container.hidden = false;
    container.innerHTML = '';

    var message = document.createElement('p');
    message.className = 'further-saved-cart__message';
    var status = document.createElement('p');
    status.className = 'further-saved-cart__status';
    var actions = document.createElement('div');
    actions.className = 'further-saved-cart__actions';

    if (hasSaved && currentSignature !== savedSignature) {
      var restoreButton = createButton(hasCurrent ? 'Add saved cart items' : 'Restore saved cart');
      restoreButton.addEventListener('click', function () {
        restoreSavedCart(saved.lines || [], currentItems, status, restoreButton);
      });
      actions.appendChild(restoreButton);
      message.textContent = hasCurrent
        ? 'Saved cart found from another device.'
        : 'Saved cart available.';
    }

    if (hasCurrent) {
      var saveToWantlistButton = createButton('Save cart to Wantlist', 'button--secondary');
      saveToWantlistButton.addEventListener('click', function () {
        saveCartToWantlist(currentItems, status, saveToWantlistButton);
      });
      actions.appendChild(saveToWantlistButton);
      if (!message.textContent) {
        message.textContent = 'Save these records for later without changing your cart.';
      }
    }

    container.appendChild(message);
    container.appendChild(actions);
    container.appendChild(status);
  }

  function restoreSavedCart(savedLines, currentItems, status, button) {
    var currentQuantities = {};
    currentItems.forEach(function (item) {
      var variantId = String(item.variant_id);
      currentQuantities[variantId] = (currentQuantities[variantId] || 0) + Math.max(0, Number(item.quantity) || 0);
    });
    var linesToAdd = savedLines.map(function (line) {
      var variantId = gidNumber(line.variant_gid);
      var savedQuantity = Math.max(1, Number(line.quantity) || 1);
      var currentQuantity = Math.max(0, Number(currentQuantities[variantId]) || 0);
      var quantityToAdd = Math.max(savedQuantity - currentQuantity, 0);
      if (!variantId || quantityToAdd <= 0) return null;
      return Object.assign({}, line, { quantity: quantityToAdd });
    }).filter(function (line) {
      return line;
    });

    if (!linesToAdd.length) {
      status.textContent = 'Saved cart items are already in your cart.';
      return;
    }

    button.disabled = true;
    status.textContent = 'Adding saved cart...';

    addLinesSequentially(linesToAdd, 0, 0).then(function (result) {
      status.textContent = result.added
        ? 'Saved cart added.'
        : 'No saved items could be added.';
      window.setTimeout(function () {
        window.location.reload();
      }, 500);
    }).catch(function () {
      status.textContent = 'Could not add saved cart.';
      button.disabled = false;
    });
  }

  function addLinesSequentially(lines, index, added) {
    if (index >= lines.length) {
      return Promise.resolve({ added: added });
    }
    var line = lines[index];
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: gidNumber(line.variant_gid),
        quantity: Math.max(1, Number(line.quantity) || 1),
      }),
    }).then(function (response) {
      return response.ok ? added + 1 : added;
    }).catch(function () {
      return added;
    }).then(function (nextAdded) {
      return addLinesSequentially(lines, index + 1, nextAdded);
    });
  }

  function saveCartToWantlist(items, status, button) {
    button.disabled = true;
    status.textContent = 'Saving...';
    fetchJson(CART_TO_WANTLIST_ENDPOINT, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ items: items }),
    }).then(function (result) {
      var created = result.created_count || 0;
      var already = result.already_saved_count || 0;
      if (created && already) {
        status.textContent = created + ' added. ' + already + ' already saved.';
      } else if (created) {
        status.textContent = created + ' added to Wantlist.';
      } else {
        status.textContent = 'Already saved to Wantlist.';
      }
      if (window.FurtherWishlist && typeof window.FurtherWishlist.refresh === 'function') {
        window.FurtherWishlist.refresh();
      }
    }).catch(function (error) {
      status.textContent = error.status === 401 ? 'Sign in to save this cart.' : 'Could not save cart.';
    }).finally(function () {
      button.disabled = false;
    });
  }

  function cartPanelMount() {
    return document.querySelector('[data-further-saved-cart-mount]')
      || document.querySelector('cart-items.is-empty .cart__warnings')
      || document.querySelector('.cart__blocks')
      || document.querySelector('.cart__warnings');
  }

  function setupCartPage() {
    var anchor = cartPanelMount();
    if (!anchor) return;

    var container = document.createElement('div');
    container.className = 'further-saved-cart';
    container.hidden = true;
    anchor.appendChild(container);

    Promise.all([
      fetchJson(CART_ENDPOINT).catch(function (error) {
        if (error.status === 401) {
          container.hidden = false;
          container.innerHTML = '<p class="further-saved-cart__message">Sign in to sync your cart across devices.</p>';
        }
        return null;
      }),
      cartJson().catch(function () { return null; }),
    ]).then(function (results) {
      var saved = results[0];
      var cart = results[1];
      if (!saved || !cart) return;
      rememberSavedCart(saved);
      renderCartPanel(container, saved, cart);
      if (!saved.lines.length && cart.item_count > 0) {
        syncItems(normalizeCartItems(cart), 0, true);
      }
    });
  }

  function markCartAddSubmit(event) {
    var form = event.target && event.target.closest ? event.target.closest('form') : null;
    if (!form || !form.action || form.classList.contains('notification-signup-form')) return;
    if (form.action.indexOf('/cart/add') === -1) return;
    try {
      window.sessionStorage.setItem('furtherSavedCartSyncAfterAdd', '1');
    } catch (error) {
      // Ignore private browsing storage failures; normal cart submission should continue.
    }
    window.setTimeout(scheduleSync, 1200);
  }

  function syncAfterAddRedirect() {
    var shouldSync = false;
    try {
      shouldSync = window.sessionStorage.getItem('furtherSavedCartSyncAfterAdd') === '1';
      if (shouldSync) window.sessionStorage.removeItem('furtherSavedCartSyncAfterAdd');
    } catch (error) {
      shouldSync = false;
    }
    if (shouldSync) {
      window.setTimeout(scheduleSync, 700);
    }
  }

  function start() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleSync);
    }
    document.addEventListener('submit', markCartAddSubmit, true);
    window.addEventListener('further:saved-cart-sync', scheduleSync);
    window.FurtherSavedCart = window.FurtherSavedCart || {};
    window.FurtherSavedCart.sync = scheduleSync;
    syncAfterAddRedirect();

    if (window.location.pathname === (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart')) {
      setupCartPage();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
